import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import { CategoryAutocomplete as CategoryAutocompleteInput } from "Components/Shared/Inputs/CategoryAutocomplete";
import type { CategoryOption } from "Types/CategoryOption";

type Props<FormType extends FieldValues> = {
  categories: Array<CategoryOption>;
  control: Control<FormType, object>;
  name: FieldPath<FormType>;
  label: string;
  disabled?: boolean;
};

export const CategoryAutocomplete = <T extends object>({
  categories,
  control,
  name,
  label,
  disabled = false,
}: Props<T>) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value }, fieldState: { error } }) => (
      <CategoryAutocompleteInput
        categories={categories}
        name={name}
        label={label}
        disabled={disabled}
        onChange={onChange}
        value={value || []}
        errorMessage={error?.message}
      />
    )}
  />
);
